import Content from './components/Content';
import Menu from './components/Menu';
import Sidebar from './components/Sidebar';

export default({Content, Menu, Sidebar});


// WEBPACK FOOTER //
// ./src/apps/client-reddit/index.js